<template>
  <div class="w-full h-full">
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="w-full max-w-7xl mx-auto flex flex-col gap-4 h-full">
      <!-- v-if="dataval == null" -->
      <div
        class="hidden 2xl:block max-sm:mt-3"
        v-if="lesson_quzing || currentQuizValue.length"
      >
        <div class="flex justify-end w-full">
          <button
            @click="resetQuiz"
            class="cursor-pointer bg-blues text-white hover:bg-hover hover:text-white px-3 py-1 text-sm font-bold rounded-2xl"
          >
            Attempt Again
          </button>
        </div>
      </div>
      <div
        class="max-w-4xl w-full rounded-3xl mx-auto flex items-center justify-center"
      >
        <div class="w-full h-full flex flex-col items-center justify-center">
          <!-- submit -->
          <div
            class="h-full w-full -mt-5"
            v-if="!lesson_quzing || !currentQuizValue.length"
          >
            <div
              v-if="questions.length > 0"
              class="w-full h-full flex flex-col justify-center items-center"
            >
              <div class="w-full h-auto flex flex-col justify-center">
                <div class="flex justify-between gap-3 max-sm:mt-3">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div
                    class="text-center text-lg font-medium px-3"
                    style="color: #01b0f9"
                  >
                    Question {{ currentQuestion + 1 }} / {{ questions.length }}
                  </div>
                  <div></div>
                  <div></div>
                  <div class="flex items-center gap-1 text-lg font-bold">
                    <!-- Clock Icon -->
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="w-5 h-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="1.5"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M12 6v6l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>

                    {{ formattedTime }}
                  </div>
                </div>

                <div
                  class="border-red-400 bg-indigo-900 h-0.5 my-10"
                  :max="30"
                  :value="countDown"
                ></div>
                <div v-if="questions[currentQuestion].image">
                  <img
                    class="w-full h-full"
                    :src="questions[currentQuestion].image"
                  />
                </div>
                <div class="text-center py-4">
                  <p class="font-semibold">
                    {{ currentQuestion + 1 }}.
                    <span
                      v-html="questions[currentQuestion].question_text"
                    ></span>
                  </p>
                </div>
                <div
                  class="flex flex-wrap justify-center gap-4 w-full"
                  v-if="questions[currentQuestion].choice_type == 'coding'"
                >
                  <div
                    class="w-full bg-gray-900 text-white rounded-lg overflow-hidden"
                  >
                    <!-- Header -->
                    <div
                      class="flex justify-between items-center px-5 py-3 bg-gray-800 border-b border-gray-700"
                    >
                      <div class="flex items-center gap-4">
                        <h3 class="text-sm font-semibold">Code Editor</h3>
                        <select
                          v-model="selectedLanguage"
                          class="px-3 py-1.5 border border-gray-700 rounded bg-gray-700 text-white text-xs cursor-pointer outline-none transition-all hover:bg-gray-600"
                          disabled
                        >
                          <option
                            v-for="lang in languages"
                            :key="lang"
                            :value="lang"
                          >
                            {{ lang.charAt(0).toUpperCase() + lang.slice(1) }}
                          </option>
                        </select>
                      </div>
                      <div class="flex items-center gap-3">
                        <button
                          @click="runCode"
                          class="px-4 py-1.5 rounded text-xs font-semibold transition-all outline-none"
                          :class="
                            isRunning
                              ? 'bg-gray-600 cursor-not-allowed opacity-60'
                              : 'bg-blues hover:bg-blue-500'
                          "
                          :disabled="isRunning"
                        >
                          <span v-if="!isRunning">▶ Run Code</span>
                          <span v-else>⏳ Running...</span>
                        </button>
                        <button
                          @click="clearCode"
                          class="px-4 py-1.5 rounded text-xs font-semibold bg-gray-700 hover:bg-gray-600 transition-all outline-none"
                        >
                          🗑️ Clear
                        </button>
                      </div>
                    </div>

                    <div class="flex" style="height: 400px">
                      <div
                        class="flex-1 flex flex-col overflow-hidden border-r border-gray-700"
                      >
                        <div
                          class="flex justify-between items-center px-4 py-2 bg-gray-800 border-b border-gray-700 text-xs font-semibold"
                        >
                          <span>📝 Editor</span>
                        </div>

                        <MonacoEditor
                          :value="code"
                          :language="selectedLanguage"
                          height="100%"
                          theme="vs-dark"
                          :options="editorOptions"
                          class="flex-1"
                          @change="handleCodeChange"
                        />
                      </div>

                      <!-- Right Side - Output -->
                      <div class="flex-1 flex flex-col overflow-hidden">
                        <div
                          class="flex justify-between items-center px-4 py-2 bg-gray-800 border-b border-gray-700 text-xs font-semibold"
                        >
                          <span>📤 Output</span>
                        </div>
                        <div class="flex-1 p-4 overflow-y-auto bg-gray-900">
                          <div
                            v-if="output"
                            class="font-mono text-xs whitespace-pre-wrap leading-relaxed"
                            :class="isError ? 'text-red-400' : 'text-gray-300'"
                          >
                            {{ output }}
                          </div>
                          <div
                            v-else
                            class="text-gray-500 italic text-center mt-12 text-xs"
                          >
                            Click "Run Code" to see output here...
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="flex flex-wrap justify-center gap-4 w-full"
                  v-if="questions[currentQuestion].choice_type == 'choice'"
                >
                  <button
                    style="border: 1px solid #01b0f9"
                    class="border rounded py-3 px-4 w-5/12 relative text-sm hover:bg-blue-900 hover:text-white"
                    :class="[
                      questions[currentQuestion].ansclk == option.id
                        ? 'bg-blue-900 text-white border-gray-400'
                        : '',
                    ]"
                    :key="index"
                    v-for="(option, index) in questions[currentQuestion]
                      .coursequizanswer_set"
                    @click="handleAnswerClick(option.is_correct, option.id)"
                  >
                    {{ option.answer_text }}
                  </button>
                </div>

                <div
                  class="flex flex-wrap justify-center gap-4 w-full"
                  v-if="questions[currentQuestion].choice_type == 'truefalse'"
                >
                  <button
                    style="border: 1px solid #01b0f9"
                    class="border rounded py-3 px-4 w-5/12 relative text-sm hover:bg-blue-900 hover:text-white"
                    :class="[
                      questions[currentQuestion].ansclk == option.id
                        ? 'bg-blue-900 text-white border-gray-400'
                        : '',
                    ]"
                    :key="index"
                    v-for="(option, index) in questions[currentQuestion]
                      .coursequizanswer_set"
                    @click="handleAnswerClick(option.is_correct, option.id)"
                  >
                    {{ option.answer_text }}
                  </button>
                </div>

                <div
                  class="flex flex-col flex-wrap justify-center gap-4 w-full"
                  v-if="
                    questions[currentQuestion].choice_type ==
                    'matchthefollowing'
                  "
                >
                  <!-- {{ questions[currentQuestion].coursequizanswer_set.left_items }}
                   -->

                  <p class="text-center text-sm">
                    Drag and drop the match the options
                  </p>

                  <div class="grid grid-cols-2 gap-10">
                    <div class="flex flex-col gap-2">
                      <div
                        v-for="left_items in questions[currentQuestion]
                          .coursequizanswer_set.left_items"
                        :key="left_items"
                        class="text-sm px-5 py-2 bg-gray-100"
                      >
                        Question: {{ left_items.value }}
                      </div>
                    </div>
                    <draggable
                      :list="
                        questions[currentQuestion].coursequizanswer_set
                          .right_items
                      "
                      class="dragArea list-group w-full flex flex-col gap-2"
                    >
                      <div
                        v-for="right_items in questions[currentQuestion]
                          .coursequizanswer_set.right_items"
                        :key="right_items"
                        class="text-sm px-5 py-2 bg-gray-200 cursor-pointer"
                      >
                        :: {{ right_items.value }}
                      </div>
                    </draggable>
                  </div>

                  <br />

                  <!-- {{ questions[currentQuestion].coursequizanswer_set.right_items }} -->

                  <!-- text -->
                  <!-- <button
                    style="border: 1px solid #01b0f9"
                    class="border rounded py-3 px-4 w-5/12 relative text-sm hover:bg-blue-900 hover:text-white"
                    :class="[
                      questions[currentQuestion].ansclk == option.id
                        ? 'bg-blue-900 text-white border-gray-400'
                        : '',
                    ]"
                    :key="index"
                    v-for="(option, index) in questions[currentQuestion]
                      .coursequizanswer_set"
                    @click="handleAnswerClick(option.is_correct, option.id)"
                  >
                    {{ option.answer_text }}
                  </button> -->
                </div>

                <div
                  class="flex flex-wrap justify-center gap-4 w-full"
                  v-if="
                    questions[currentQuestion].choice_type == 'shortdescription'
                  "
                >
                  <textarea
                    class="w-full border rounded-lg p-2"
                    rows="5"
                    required
                    v-model="questions[currentQuestion].short_description"
                  >
                  </textarea>
                </div>

                <div
                  class="flex flex-wrap justify-center gap-4 w-full"
                  v-if="questions[currentQuestion].choice_type == 'description'"
                >
                  <textarea
                    class="w-full border rounded-lg p-2"
                    rows="5"
                    required
                    v-model="questions[currentQuestion].description"
                  >
                  </textarea>
                </div>
              </div>
            </div>

            <div
              v-if="questions.length > 0"
              class="max-w-4xl bg-gray-200 overflow-x-auto"
              style="min-width: 360px"
            ></div>
            <div
              v-if="questions.length > 0"
              class="md:mt-20 mt-5 pb-5 flex flex-col md:flex-row gap-4 md:gap-10 justify-center items-center"
            >
              <!-- Previous -->
              <button
                v-if="currentQuestion > 0"
                :disabled="disable_submit == true"
                :class="
                  disable_submit
                    ? 'bg-gray-200 text-black cursor-not-allowed'
                    : 'gradient-btn hover:bg-hover'
                "
                class="w-full md:w-[160px] py-2"
                @click="pvsQt"
              >
                Previous
              </button>

              <!-- Next -->
              <button
                v-if="currentQuestion + 1 < questions.length"
                class="gradient-btn w-full md:w-[160px] py-2"
                @click="nxtQt"
              >
                Next
              </button>

              <!-- Preview Submit + Loader -->
              <div
                class="flex gap-3 items-center w-full md:w-auto justify-center"
              >
                <button
                  v-if="currentQuestion + 1 == questions.length"
                  @click="ckans_old"
                  :disabled="disable_submit == true"
                  :class="
                    disable_submit
                      ? 'bg-gray-200 text-black cursor-not-allowed'
                      : 'gradient-btn hover:bg-hover'
                  "
                  class="w-full md:w-[160px] py-2"
                >
                  Preview Submit
                </button>

                <img
                  v-if="disable_submit"
                  src="@/assets/loading.gif"
                  alt="loading"
                  class="w-6 h-6 object-contain"
                />
              </div>
            </div>
          </div>

          <div v-else class="h-full w-full -mt-5">
            <div class="flex justify-end 2xl:hidden max-sm:mt-3">
              <button
                @click="resetQuiz"
                class="cursor-pointer bg-blues text-white hover:bg-hover hover:text-white px-3 py-1 text-sm font-bold rounded-2xl"
              >
                Attempt Again
              </button>
            </div>

            <div class="pb-10" v-if="currentQuizValue[0]">
              <template
                v-for="(el, index) in currentQuizValue[0]
                  .coursequizusersanswer_set"
              >
                <div
                  v-if="
                    el && el.question && el.question.choice_type !== 'coding'
                  "
                  :key="index"
                  class="border max-w-4xl mx-auto mt-4 text-start p-10 rounded-3xl"
                >
                  <p class="py-2 font-bold">
                    {{ index + 1 }} {{ el.question.question_text }}
                  </p>

                  <!-- {{ el }} -->

                  <!-- changes need to do..-->
                  <div
                    v-if="
                      el.question.choice_type === 'choice' ||
                      el.question.choice_type === 'truefalse'
                    "
                  >
                    <div
                      v-for="(al, index) in el.question.coursequizanswer_set"
                      :key="al"
                    >
                      <p
                        class=""
                        :class="[
                          al.is_correct == true
                            ? 'text-blue-900 font-bold'
                            : '',
                        ]"
                      >
                        {{ index + 1 }}) {{ al.answer_text }} <br />
                      </p>
                    </div>

                    <div class="px-6 mt-6 py-6 rounded-2xl border my-2">
                      <h1
                        class="px-5 lg:px-5 py-2 lg:py-4 items-center border-gray-200 bg-gray-100 text-xs font-semibold rounded-2xl text-gray-600 tracking-wider"
                      >
                        Your Answer
                      </h1>
                      <p
                        v-if="el.answer"
                        class="px-4 text-sm font-bold"
                        :class="[
                          el.answer.is_correct == true
                            ? 'text-green-700'
                            : 'text-red-400',
                        ]"
                      >
                        {{ el.answer.answer_text }}
                      </p>
                      <p v-else class="px-4 text-sm font-bold">Not attend</p>
                    </div>
                  </div>

                  <div
                    v-if="el.question.choice_type === 'description'"
                    class="px-6 mt-6 py-6 rounded-2xl border my-2"
                  >
                    <h1
                      class="px-5 lg:px-5 py-2 lg:py-4 items-center border-gray-200 bg-gray-100 text-xs font-semibold rounded-2xl text-gray-600 tracking-wider"
                    >
                      Your Answer
                    </h1>
                    <p
                      v-if="el.description != null"
                      class="px-4 text-sm font-bold mt-2"
                    >
                      {{ el.description }}
                    </p>
                  </div>

                  <div
                    v-if="el.question.choice_type === 'shortdescription'"
                    class="px-6 mt-6 py-6 rounded-2xl border my-2"
                  >
                    <h1
                      class="px-5 lg:px-5 py-2 lg:py-4 items-center border-gray-200 bg-gray-100 text-xs font-semibold rounded-2xl text-gray-600 tracking-wider"
                    >
                      Your Answer
                    </h1>
                    <p
                      v-if="el.short_description != null"
                      class="px-4 text-sm font-bold mt-2"
                    >
                      {{ el.short_description }}
                    </p>
                  </div>

                  <div
                    class="flex flex-col flex-wrap justify-center gap-4 w-full"
                    v-if="el.question.choice_type == 'matchthefollowing'"
                  >
                    <div class="grid grid-cols-2 gap-10 pt-5">
                      <div class="flex flex-col gap-2">
                        <div
                          v-for="left_items in el.match_answer.left_items"
                          :key="left_items"
                          class="text-sm px-5 py-2 bg-gray-100"
                        >
                          Question: {{ left_items.value }}
                        </div>
                      </div>
                      <draggable
                        :list="el.match_answer.right_items"
                        class="dragArea list-group w-full flex flex-col gap-2"
                      >
                        <div
                          v-for="right_items in el.match_answer.right_items"
                          :key="right_items"
                          class="text-sm px-5 py-2 bg-gray-200 cursor-pointer"
                        >
                          {{ right_items.value }}
                        </div>
                      </draggable>
                    </div>

                    <br />
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import FlashMessage from "@/components/FlashMessage.vue";
// import draggable from 'vuedraggable';
import { defineComponent } from "vue";
import { VueDraggableNext } from "vue-draggable-next";
import MonacoEditor from "monaco-editor-vue3";
export default {
  name: "testMCqview",
  data() {
    return {
      currentQuestion: 0,
      countDown: 840,
      showScore: false,
      questions: [],
      tst: false,
      score: 0,
      is_completed: false,
      is_submit: false,
      nextquz: 0,
      message: "",
      mcqset: "",
      dataval: null,
      answeredData: "",
      currentAnsweredQuestion: 0,
      messages: {
        text: "",
        type: "null",
      },
      loading: false,
      disable_submit: false,
      // quiz_details: [],
      // currentQuizDetails: ""
      currentQuizValue: [],
      quizpreview: false,
      lesson_quzing: null,
      codingAnswers: {},
      code: "",
      output: "",
      isError: false,
      isRunning: false,
      selectedLanguage: "python",
      languages: ["python", "c", "cpp", "java", "Javascript"],
      editorOptions: {
        theme: "vs-dark",
        fontSize: 13,
        automaticLayout: true,
        minimap: { enabled: false },
        scrollBeyondLastLine: false,
        lineNumbers: "on",
        roundedSelection: false,
        scrollbar: {
          vertical: "visible",
          horizontal: "visible",
        },
      },
      duration: "",
      timeLeft: 0,
      timerInterval: null,
      endTime: null,
      isAutoSubmit: false,
    };
  },
  props: ["quiz_id", "taker_id", "course_id", "lesson_quiz_id"],
  beforeUnmount() {
    this.cleanupQuizTimer();
  },
  beforeRouteLeave(to, from, next) {
    this.cleanupQuizTimer();
    next();
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "userInfo",
      "profileInfo",
      "cartInfo",
      "courseTrackerInfo",
      "subscriptionInfo",
    ]),
    formattedTime() {
      if (!this.timeLeft || isNaN(this.timeLeft)) return "00:00";

      const minutes = Math.floor(this.timeLeft / 60);
      const seconds = this.timeLeft % 60;

      return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
        2,
        "0"
      )}`;
    },
  },

  components: {
    FlashMessage,
    MonacoEditor,
    draggable: VueDraggableNext,
  },
  mounted() {
    this.$watch(
      () => this.questions,
      (newVal) => {
        if (newVal && newVal.length > 0) {
          this.loadCodingQuestion();
        }
      },
      { deep: true, immediate: true }
    );
  },
  async created() {
    this.mcqCall();
    this.tst = false;
    this.countDownTimer();

    let token = this.userInfo.token_key;

    // this.getQuiz();


    // if (this.taker_id != null) {
    //   axios
    //     .get(
    //       `${process.env.VUE_APP_API}/quiztaker__quizzes_pk/${this.taker_id}/?Key=${token}`
    //     )
    //     .then((response) => {
    //       if (response.data.status == 200) {
    //         this.dataval = response.data.data;
    //       }
    //       console.log("response:: test", response.data.message);
    //     });
    // }
    // this.quizPreview();
  },
  watch: {
    duration: {
      handler(newVal) {
        if (newVal?.quiz?.timer) {
          this.startQuizTimer();
        }
      },
      deep: true,
      immediate: true,
    },
    currentQuestion(newVal) {
      if (
        this.questions[newVal] &&
        this.questions[newVal].choice_type === "coding"
      ) {
        this.loadCodingQuestion();
      }
    },
    lesson_quiz_id: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.getSUbmittedQuiz(newVal);
        } else {
          this.currentQuizValue = [];
          this.questions = [];
          this.lesson_quzing = null;
        }
      },
    },
  },

  // mounted() {
  //   if (this.lesson_quiz_id) {
  //     this.getSUbmittedQuiz(this.lesson_quiz_id);
  //   } else {
  //     // alert("lesson_quiz_id is null, API call skipped");
  //     // this.currentQuizValue = [];
  //   }
  // },

  methods: {
    startQuizTimer() {
      if (!this.duration?.quiz?.timer) return;

      const savedTime = localStorage.getItem("quiz_time_left");

      this.timeLeft = savedTime
        ? parseInt(savedTime)
        : this.duration.quiz.timer * 60;

      if (this.quizInterval) clearInterval(this.quizInterval);

      this.quizInterval = setInterval(() => {
        this.timeLeft--;

        localStorage.setItem("quiz_time_left", this.timeLeft);

        if (this.timeLeft <= 0) {
          clearInterval(this.quizInterval);
          this.timeLeft = 0;
          localStorage.removeItem("quiz_time_left");
          this.isAutoSubmit = true;
          this.ckans();
        }
      }, 1000);
    },
    resetQuiz() {
      // Reset quiz state
      this.cleanupQuizTimer();
      this.currentQuizValue = [];
      this.questions = [];
      this.lesson_quzing = null;
      this.currentQuestion = 0;
      this.score = 0;
      this.disable_submit = false;
      this.mcqCall();
    },
    async mcqCall() {
      // course_quizzes_pk
      let token = this.userInfo.token_key;
      await axios
        .get(
          `${process.env.VUE_APP_API}/course_quizzes_pk/${this.quiz_id}/?Key=${token}`
        )
        .then((r) => {
          this.mcqset = r.data.data[0];
          this.questions = r.data.data[0].quiz.coursequizquestion_set;
          this.duration = r.data.data[0].quiz.quiztakers_set;
          if (this.questions) {
            this.questions.forEach((el) => {
              el.ansclk = "";
              el.anr = false;
            });
          }
        });
    },
    clearCode() {
      this.code = this.questions[this.currentQuestion].starter_code || "";
      this.output = "";
      this.isError = false;
    },
    handleCodeChange(newCode) {
      this.code = newCode;
      const questionId = this.questions[this.currentQuestion].id;
      if (!this.codingAnswers[questionId]) {
        this.codingAnswers[questionId] = {};
      }
      this.codingAnswers[questionId].coding = newCode;
    },

    loadCodingQuestion() {
      const currentQ = this.questions[this.currentQuestion];
      if (currentQ.choice_type === "coding") {
        if (currentQ.programming_language) {
          this.selectedLanguage = currentQ.programming_language.toLowerCase();
        }

        const questionId = currentQ.id;
        if (
          this.codingAnswers[questionId] &&
          this.codingAnswers[questionId].coding
        ) {
          this.code = this.codingAnswers[questionId].coding;
          this.output = this.codingAnswers[questionId].output || "";
        } else {
          this.code = currentQ.starter_code || "";
          this.output = "";
        }

        this.isError = false;
      }
    },

    async runCode() {
      if (!this.code?.trim()) {
        this.output = "Error: No code to execute";
        this.isError = true;
        return;
      }

      if (!this.selectedLanguage) {
        this.output = "Error: No programming language selected";
        this.isError = true;
        return;
      }

      this.isRunning = true;
      this.isError = false;
      this.output = "Running code...";

      try {
        const { data } = await axios.post(
          `${process.env.VUE_APP_API}/compiler/`,
          { code: this.code, language: this.selectedLanguage }
        );

        if (data.status === 400 || data.errors) {
          this.output = data.errors || "Compilation/Runtime Error";
          this.isError = true;
        } else if (data.output) {
          this.output = Array.isArray(data.output)
            ? data.output.length
              ? data.output.join("\n")
              : "Code executed successfully with no output"
            : data.output;
          this.isError = false;
        } else {
          this.output = "Code executed successfully with no output";
          this.isError = false;
        }

        const qid = this.questions[this.currentQuestion].id;
        this.codingAnswers[qid] = {
          output: this.output,
          coding: this.code,
        };
      } catch (error) {
        console.error("Error running code:", error);
        this.isError = true;

        const res = error.response?.data;

        if (res?.errors) this.output = res.errors;
        else if (res?.error) this.output = res.error;
        else if (res?.output) {
          this.output = Array.isArray(res.output)
            ? res.output.length
              ? res.output.join("\n")
              : "Error occurred with no output"
            : res.output;
        } else if (res?.message) this.output = res.message;
        else if (error.request) {
          this.output =
            "Connection Error: Unable to reach server.\n\nCheck:\n1. Backend running\n2. /compiler/ reachable\n3. Internet stable";
        } else this.output = `Error: ${error.message}`;
      } finally {
        this.isRunning = false;
      }
    },
    handleAnswerClick(isCorrect, id) {
      this.questions[this.currentQuestion].ansclk = id;
      this.questions[this.currentQuestion].anr = isCorrect;
      let nextQuestion = this.currentQuestion + 1;

      if (nextQuestion < this.questions.length) {
        this.currentQuestion = nextQuestion;
      }
    },
    countDownTimer() {
      if (this.countDown > 0) {
        this.timer = setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    submitMcq() {
      this.showScore = true;
      localStorage.setItem("mcqTstv", true);
      this.tst = true;
    },
    nxtQt() {
      let nextQuestion = this.currentQuestion + 1;
      if (nextQuestion < this.questions.length) {
        this.currentQuestion = nextQuestion;
      }
    },
    pvsQt() {
      if (this.currentQuestion > 0) {
        let nextQuestion = this.currentQuestion - 1;
        if ((nextQuestion) => 0) {
          this.currentQuestion = nextQuestion;
        }
      }
    },

    nxtQtSubmitted() {
      if (
        this.currentAnsweredQuestion <
        this.dataval.coursequizusersanswer_set.length
      ) {
        this.currentAnsweredQuestion = this.currentAnsweredQuestion + 1;
      }
    },

    pvsQtSubmitted() {
      if (this.currentAnsweredQuestion > 0) {
        this.currentAnsweredQuestion = this.currentAnsweredQuestion - 1;
      }
    },

    async getSUbmittedQuiz(id) {
      let token = this.userInfo.token_key;

      axios
        .get(
          `${process.env.VUE_APP_API}/quiztaker__quizzes_pk/${this.quiz_id}/?Key=${token}&id=${id}`
        )
        .then((response) => {
          if (response.data.status === 200) {
            this.currentQuizValue = response.data.data || [];
            this.questions = response.data.data?.[0]?.questions || [];
            this.lesson_quzing = response.data.data?.[0] || null;

          } else {
            this.currentQuizValue = [];
            this.questions = [];
            this.lesson_quzing = null;
          }
          console.log("response:: test", response.data.message);
        });
    },

    async ckans() {
      this.messages = {
        text: "Preview Quiz Submitted.",
        type: "success",
      };

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "",
        };
      }, 3000);
    },
    cleanupQuizTimer() {
      if (this.quizInterval) {
        clearInterval(this.quizInterval);
        this.quizInterval = null;
      }

      localStorage.removeItem("quiz_time_left");
    },
    async ckans_old() {
      if (!this.questions || this.questions.length === 0) return;
      this.disable_submit = true;
      var ans_set = [];
      let token = this.userInfo.token_key;
      this.questions.forEach((el) => {
        let answerValue = null;

        if (el.ansclk !== undefined && el.ansclk !== "" && el.ansclk !== null) {
          answerValue = el.ansclk;
        }

        let descriptionValue = el.description ? el.description : null;

        let shortDescriptionValue = el.short_description
          ? el.short_description
          : null;

        let matchValue =
          el.coursequizanswer_set && el.coursequizanswer_set.length > 0
            ? el.coursequizanswer_set
            : null;

        let val = {
          question: el.id,
          answer: answerValue,
          description: descriptionValue,
          short_description: shortDescriptionValue,
          match_answer: matchValue,
        };
        if (el.choice_type === "coding" && this.codingAnswers[el.id]) {
          val.coding = this.codingAnswers[el.id].coding || "";
          val.output = this.codingAnswers[el.id].output || "";
        }
        ans_set.push(val);
        if (el.anr) {
          this.score += 1;
        }
      });

      this.HeaderVal = {
        score: this.score,
        quiz: this.mcqset.quiz.course,
        quiz_id:this.mcqset.quiz.id,
        quiz_title: this.mcqset.quiz.name,
        usersanswer: ans_set,
        completed: true,
      };
      await axios
        .patch(
          `${process.env.VUE_APP_API}/course_save_multi_answer/?Key=${token}`,
          this.HeaderVal
        )
        .then((response) => {
          this.cleanupQuizTimer();
          this.loading = false;
          if (response.data.status == 200) {
            this.lesson_quzing = response.data.data;
            this.messages = {
              text: "Quiz Submitted.",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "",
              };
              this.quizspreview = false;

              // this.$emit("pushLessonComplete");
              const quizId = response.data.data?.id || response.data.data;
              this.getSUbmittedQuiz(quizId);
              this.disable_submit = false;
              // setTimeout(()=>{
              //   window.location.reload();
              // }, 500)
              //
            }, 2000);
            this.getSUbmittedQuiz(response.data.data);
          }
        });
    },
  },
};
</script>

<style scoped>
.gradient-btn {
  background: #0f172a;
  --tw-shadow: 0 10px 30px -3px rgba(255, 31, 57, 0.1),
    0 10px 30px -6px rgba(255, 31, 57, 0.3);
  transition: all 0.2s linear;
  color: white;
  border: 0px;
  padding: 8px 16px;
  outline: 2px solid transparent;
  outline-offset: 2px;
  border-radius: 0.25rem;
  font-size: 1rem;
  line-height: 1.5rem;
  min-width: 160px;
  font-weight: 700;
}
</style>
